import React from "react";
import {Button, Checkbox, DatePicker, Input, message, Modal, Table, Tooltip} from "antd";
import {HotSheetDownloadCSV, HotSheetList, HotSheetPDFList, HotSheetRemove} from "../../../models/hotsheet";
import {ImportQuote} from "./popups/ImportQuote";
import {AddUpdateHotSheet} from "./popups/AddUpdateHotSheet";
import {ShowHotSheet} from "./popups/ShowHotSheet";
import {ChoiceHotSheetCreate} from "./popups/ChoiceHotSheetCreate";
import {download, pagination, Role, toList, UserContext} from "../../../controller/Utils";
import {TrackHeaderLink} from "../TrackHeaderLink";
import {Config} from "../../../controller/Global";
import {Link} from "react-router-dom";

const {RangePicker} = DatePicker;
const confirm = Modal.confirm;
const Search = Input.Search;
const HOTSHEET = Config.constant.service_type.hotsheet;
const MANIFEST = Config.constant.service_type.manifest;

export class HotSheet extends React.Component {
  static contextType = UserContext;
  state = {
    data: [],
    pagination: pagination,
    value: [],
    loading: false,
    printVisible: false,
    selectedRowKeys: [],
    params: {},
    printChoices: {},
    popvisible: false,
    printBtnLoading: false,
    downloadLoading: false,
  };

  showPrintHotSheet = (row_id) => {
    this.setState({
      printVisible: true,
      row_id: row_id
    });
    // HotSheetPDFList({ids: row_id, pdf_type: HOTSHEET})
  }
  handleCancel = () => {
    this.setState({
      printVisible: false,
    });
  }

  hide = () => {
    this.setState({
      popvisible: false,
    });
  }
  PDFPrintOption = (counter = 0) => {
    const {row_id, printChoices} = this.state;
    const data = toList(printChoices);
    const key = Object.keys(printChoices)[counter]
    if (key === HOTSHEET) {
        HotSheetPDFList({ids: row_id, pdf_type: HOTSHEET})
          .then(response => {
            counter += 1;
            if (data.length === counter)
              this.setState({printBtnLoading: false, printVisible: false, printChoices: {}});
             else
               this.PDFPrintOption(counter, data)
          })
      }
      else if (key.startsWith(MANIFEST)) {
        HotSheetPDFList({ids: row_id, pdf_type: MANIFEST})
          .then(response => {
            counter += 1;
            if (data.length === counter)
              this.setState({printBtnLoading: false, printVisible: false, printChoices: {}})
            else
              this.PDFPrintOption(counter, data)
          })
      }
  }
  selectedChoicesPrint = (e) => {
    let {printChoices} = this.state;
    if (!e.target.checked)
      delete printChoices[e.target.name];
    else {
      printChoices[e.target.name] = e.target.value;
      this.setState({printChoices});
    }
  }
  onHotSheetRowPrintClick = () => {
    this.setState({printBtnLoading: true});
    this.PDFPrintOption()
  };

  handleVisibleChange = (popvisible) => {
    this.setState({popvisible});
  }

  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({selectedRowKeys});
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = {...this.state.pagination};
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.field}`,
      ...filters,
    });
  };
  fetch = (params = {}) => {
    params =  {...this.state.params, ...params};
    this.setState({loading: true, params});
    params['table'] = true;
    HotSheetList(params)
      .then(response => {
        const pagination = {...this.state.pagination};
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  onRowDeleteClick = (keys) => {
    const $this = this;
    confirm({
      title: 'Are you sure delete this Hot Sheet(s)?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      centered: true,
      onOk() {
        keys.forEach(id => {
          HotSheetRemove(id)
            .then(response => {
              message.success('Hot Sheet(s) deleted successfully');
              $this.fetch();
            });
        });
      },
    });
  };
  onRowShowClick = (ids) => {
    this.setShowHotSheetModel(true);
    this.setState({showHotSheetModelData: ids})
  };
  onRowUpdateClick = (moderatedHotSheet) => {
    this.setState({moderatedHotSheet});
    this.setAddUpdateHotSheetModel(true);
  };
  columns = [
    {
      title: 'Action',
      render: item => <div className="action-column">
        <a title="View" onClick={() => this.onRowShowClick([item.id])}><i className="fa fa-eye"/></a>
        {!item.service.heat && <a title="Edit" onClick={() => this.onRowUpdateClick(item.id)}><i className="fa fa-pencil"/></a>}
        {!item.service.heat && <Role allow={["admin"]} user={this.context.user}><a title="Delete" onClick={() => this.onRowDeleteClick([item.id])}><i className="fa fa-trash"/></a></Role>}
        {/*{!item.service.heat && <a title="Print" className={item.print?'is-print-btn':''} onClick={() => this.showPrintHotSheet(item.id)} ><i className="icon-printer" /></a>}*/}
      </div>
    },
    {
      title: 'HotSheet Number',
      dataIndex: 'hot_sheet_number',
      sorter: true
    },
    {
      title: <span className="billto-column-tbl">Hotsheet Type</span>,
      dataIndex: 'hot_sheet_type',
      key: 'code',
      sorter: true
    },
    {
      title: <span className="billto-column-tbl">Generator</span>,
      dataIndex: 'generator',
      render: generator => <Tooltip placement="top"
                                    title={`${generator.address} ${generator.city} ${generator.zip_code}`}><span
        className="uppercase-letter">{generator.company_name}<br/>ID: {generator.account_number}<i
        className="fa fa-info-circle"/></span></Tooltip>,
      sorter: true
    }, {
      title: <span className="billto-column-tbl">User</span>,
      dataIndex: 'user',
      render: (user) => user ? `${user.first_name} ${user.last_name}` : 'N/A',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Bill To</span>,
      dataIndex: 'bill_to',
      render: bill_to => <Tooltip placement="top" title={`${bill_to.address} ${bill_to.city} ${bill_to.zip_code}`}><span>{bill_to.company_name}<br /> ID: {bill_to.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
    }, {
      title: 'Transporter',
      dataIndex: 'service',
      key: 'transporter',
      render: service => service.transporter.name
    },
    {
      title: 'Cycle',
      dataIndex: 'service',
      key: 'cycle',
      render: service => service.cycle,
    },
    {
      title: 'Service Date',
      dataIndex: 'service',
      key: 'service_date',
      render: service => service.prev_service_date,
    },
    {
      title: 'Next Service Date',
      dataIndex: 'service',
      key: 'next_service_date',
      render: service => service.heat?'-': service.next_service_date
    }, {
      title: 'Status',
      dataIndex: 'service',
      key: 'status',
      render: (service) => <span className={service.status}><i className="fa fa-circle"/></span>
    }
  ];
  // onMultipleRowPrintClick = () => {
  //   const {selectedRowKeys} = this.state;
  //   if (selectedRowKeys.length) {
  //     HotSheetPDFList({ids: selectedRowKeys})
  //   }
  //   else {
  //     HotSheetPDFList(this.state.params)
  //   }
  // };
   onMultipleRowPrintClick = () => {
    const {params, selectedRowKeys} = this.state;
    HotSheetPDFList({...params, 'pdf_type': 'hotsheet_manifest', 'ids':selectedRowKeys})
  }
  onMultipleRowDeleteClick = () => {
    const {selectedRowKeys} = this.state;
    if (selectedRowKeys.length)
      this.onRowDeleteClick(selectedRowKeys);
    else
      message.info('Please select any one row for delete');
    this.setState({
      selectedRowKeys: []
    })
  };

  onMultipleRowShowClick = () => {
    const {selectedRowKeys} = this.state;
    if (selectedRowKeys.length)
      this.onRowShowClick(selectedRowKeys);
    else
      message.info('Please select any one row for show');
  };

  openImportQuoteModel = (selectQuoteVisible) => {
    this.setState({selectQuoteVisible});
    this.setChoiceHotSheet(false);
  };
  openAddNewHotSheet = () => {
    this.setState({moderatedHotSheet: false});
    this.setAddUpdateHotSheetModel(true);
    this.setChoiceHotSheet(false)
  };
  onDateRangeChange = (date, dateString) => {
    this.fetch({
      next_date_fields: 'next_service_date',
      start_date: dateString[0],
      end_date: dateString[1],
    })
  };

  setAddUpdateHotSheetModel(addUpdateHotSheetModel) {
    this.setState({addUpdateHotSheetModel});
  }

  setShowHotSheetModel(showHotSheetModel) {
    this.setState({showHotSheetModel});
  }

  setSelectQuoteVisible(selectQuoteVisible) {
    this.setState({selectQuoteVisible});
  }

  setChoiceHotSheet(setChoiceHotSheetModel) {
    this.setState({setChoiceHotSheetModel})
  }


  downloadCSV = async () => {
    this.setState({downloadLoading: true})
    const res = await HotSheetDownloadCSV({
      ...this.state.params,
      results: this.state.pagination.pageSize || 25,
      page: this.state.pagination.current || 1,
    }).finally(() => {this.setState({downloadLoading: false})})
    const blob = await res.blob()
    const url = URL.createObjectURL(blob);
    download(url, 'HotSheets.csv');
    URL.revokeObjectURL(url)
  }

  componentDidMount() {
    this.fetch();
  }


  render() {
    const { pagination, data, loading, selectedRowKeys, row_id, printBtnLoading, downloadLoading } = this.state;
    const user = this.context.user
    const rowSelection = {
      selectedRowKeys,
      getCheckboxProps: record => ({
        disabled: record.service.heat,
      }),
      onChange: this.onCheckboxSelectChange,
    };
    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-2 col-12">
                <h3 className="main-heading">AB Tracks</h3>
              </div>
              <div className="col-sm-10 col-12">
                <TrackHeaderLink />
              </div>
            </div>
            <div className="row clearfix edit-header">
              <div className="col-lg-3 col-12 offset-lg-9">
                <Link className="btn submit-btn" to='/dashboard/manage-hotsheet/'>Manage Hotsheets</Link>
              </div>
            </div>
              <div className="row clearfix edit-header">
              <div className="col-lg-4 col-sm-4 col-12">
                <div id="date_range_wrapper">
                  <RangePicker onChange={this.onDateRangeChange} />
                </div>
              </div>
              <div className="col-lg-2 col-sm-2 col-2 padding-0 pull-xs-left">
                <button className="btn submit-btn xs-hide" type="button"
                  onClick={() => this.setChoiceHotSheet(true)}>Create Hotsheet
                </button>
                <button className="btn submit-btn xs-show" type="button" onClick={() => this.setChoiceHotSheet(true)}><i
                  className="fa fa-plus" /></button>
              </div>
              <div className="col-lg-3 col-sm-5 col-10 pull-xs-right hotsheet-search">
                <Search placeholder="Input search text" onSearch={value => this.fetch({ search: value })}
                  style={{ width: "100%" }} />
              </div>
              <div className="col-lg-3 col-sm-12 col-12 edit-div">
                <span>{pagination.total} Records</span>
                <Role allow={["admin"]} user={user}>
                  <button className="btn btn-edit" onClick={this.onMultipleRowDeleteClick}>
                    <i className="fa fa-trash-o" />
                  </button>
                </Role>
                <button type="primary" onClick={this.onMultipleRowShowClick} className="btn btn-edit">
                  <i className="fa fa-eye" />
                </button>
                <button type="primary" onClick={this.onMultipleRowPrintClick} className="btn btn-edit">
                  <i className="icon-printer" />
                </button>
                <Button
                    className={'btn btn-edit'}
                    type="primary"
                    icon="download"
                    onClick={this.downloadCSV}
                    loading={downloadLoading}
                    disabled={downloadLoading}
                    style={{ borderRadius: 0, minWidth: '42px' }}
                />
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-12">
                <div className="listing-table">
                  <Table
                    className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                    pagination={pagination} rowSelection={rowSelection} rowKey={row => row.id} columns={this.columns}
                    dataSource={data} loading={loading} onChange={this.handleTableChange}
                    locale={{ emptyText: 'No Hot Sheet Available' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal">
          <AddUpdateHotSheet moderated={this.state.moderatedHotSheet} visible={this.state.addUpdateHotSheetModel} setModelVisible={() => this.setAddUpdateHotSheetModel(false)} fetch={() => this.fetch()} />
        </div>
        <ShowHotSheet visible={this.state.showHotSheetModel} setModelVisible={() => this.setShowHotSheetModel(false)} data={this.state.showHotSheetModelData} />
        <ChoiceHotSheetCreate visible={this.state.setChoiceHotSheetModel} importQuote={() => this.openImportQuoteModel(true)} addNewHotSheet={() => this.openAddNewHotSheet(true)} setModelVisible={() => this.setChoiceHotSheet(false)} />
        <ImportQuote visible={this.state.selectQuoteVisible} fetch={() => this.fetch()} setModelVisible={() => this.setSelectQuoteVisible(false)} />
        <Modal title="Select Print Option" confirmLoading={printBtnLoading} visible={this.state.printVisible} onOk={this.onHotSheetRowPrintClick} onCancel={this.handleCancel} okText="Download PDF" className="print-modal" width={300} destroyOnClose={true}>
        <div>
          <div className="check-div">
            <Checkbox name={HOTSHEET} value={row_id} onChange={this.selectedChoicesPrint}>Print Hot Sheet</Checkbox>
          </div>
          {data.map(row => {
            return (row.id === row_id &&
              <div key={row.id} className="check-div uppercase-letter">
                  <Checkbox value={row.service.manifest_number} name={MANIFEST} onChange={this.selectedChoicesPrint}>Print {row.service.type}: {row.service.manifest_number}</Checkbox>
              </div>)
          })}
        </div>
      </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/tracks/hotsheet/HotSheet.jsx